import { Link } from "react-router-dom";
import { deepArticles } from "@/lib/chiguaData";
import SectionHeading from "@/components/chigua/SectionHeading";
import StoryCard from "@/components/chigua/StoryCard";

export default function FeatureDeep() {
  const lead = deepArticles.find((a) => a.timeline) ?? deepArticles[0];
  const rest = deepArticles.filter((a) => a.slug !== lead.slug);

  return (
    <section className="border-b border-background-200 bg-background-100/50">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="深扒档案"
          title="内幕真相 · 时间线复盘"
          desc="把零散线索按时间串联、交叉比对关键节点，让内幕消息的来龙去脉自然浮现——只整理公开材料，不做主观猜测。"
          action="进入深扒档案"
          actionTo="/list/shenba"
        />

        <div className="grid gap-8 lg:grid-cols-12">
          {/* 主打时间线专题 */}
          <article className="relative overflow-hidden rounded-xl border border-accent-200/70 bg-accent-100/40 p-6 md:p-8 lg:col-span-7">
            <span className="pointer-events-none absolute -right-6 -top-6 h-32 w-32 rounded-full bg-accent-200/50 blur-2xl" aria-hidden="true" />
            <div className="flex flex-wrap items-center gap-2 text-xs">
              <span className="inline-flex items-center gap-1 rounded-md bg-accent-500 px-2.5 py-1 font-semibold text-background-50">
                <i className="ri-node-tree" aria-hidden="true" />
                完整时间线专题
              </span>
              <span className="rounded-md bg-background-50/80 px-2.5 py-1 text-foreground-600">{lead.date}</span>
            </div>

            <Link to={`/story/${lead.slug}`}>
              <h3 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 transition hover:text-accent-800 md:text-[28px]">
                {lead.title}
              </h3>
            </Link>
            <p className="mt-3 max-w-2xl text-sm leading-6 text-foreground-700 md:text-[15px]">{lead.dek}</p>

            {/* 时间线预览 */}
            {lead.timeline && (
              <ol className="mt-6 space-y-0">
                {lead.timeline.slice(0, 4).map((p) => (
                  <li key={p.time} className="relative flex gap-4 pb-4 last:pb-0">
                    <span className="flex flex-col items-center">
                      <span className="mt-1 h-2.5 w-2.5 rounded-full border-2 border-accent-500 bg-background-50" aria-hidden="true" />
                      <span className="mt-1 w-px flex-1 bg-accent-300/70" aria-hidden="true" />
                    </span>
                    <div>
                      <p className="font-label-sc text-xs uppercase tracking-widest text-accent-700">{p.time}</p>
                      <p className="mt-0.5 text-sm font-medium text-foreground-900">{p.title}</p>
                      <p className="mt-1 hidden text-xs leading-5 text-foreground-600 sm:block">{p.text}</p>
                    </div>
                  </li>
                ))}
              </ol>
            )}

            <Link
              to={`/story/${lead.slug}`}
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
            >
              展开完整复盘
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </article>

          {/* 右侧更多深扒 */}
          <div className="lg:col-span-5">
            <div className="space-y-5 rounded-xl border border-background-200 bg-background-50 p-6">
              {rest.slice(0, 3).map((a) => (
                <StoryCard key={a.slug} item={a} />
              ))}
              <Link
                to="/list/shenba"
                className="inline-flex items-center gap-1 text-sm font-medium text-accent-700 transition hover:text-accent-800"
              >
                查看全部深扒复盘
                <i className="ri-arrow-right-down-line" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}